<template>
  <div>
    <p v-if="loggedIn" class="logged-in">
      <translate :tt="{ email: loggedInUserEmail }">
        You are logged in as {email}
      </translate>
      <translate tag="a" class="log-out" @click.prevent="$emit('logout')">
        Booking log out
      </translate>
    </p>
    <login-modal v-else :modal-hash="modalHash" :email="email">
      <translate
        data-test="booking-log-in-button"
        tag="button"
        type="button"
        class="primary small"
        @click.prevent="$emit('login')"
      >
        I already have an account log in
      </translate>
    </login-modal>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  emits: ['login'],
})
class AccountSection extends Vue {
  modalHash = `login-form-${Date.now()}`
  @Prop()
  email: string

  @Prop()
  loggedInUserEmail: string

  @Prop()
  loggedIn: boolean
}

export default toNative(AccountSection)
</script>

<style scoped>
p {
  font-size: var(--body);
  padding-right: 0.75em;
}

button {
  box-shadow: none;
  padding: 0.4em 0.5em 0.4em;
}

.log-out {
  color: var(--colour-text-light);
}

.logged-in {
  margin: 0 0 1em 0;
}

.row {
  align-items: center;
  justify-content: flex-start;
}

.help-text {
  margin-top: 0.5em;
}
</style>
